import { Box, Popover, useTheme } from "@mui/material";
import toHtmlColor from "@utils/toHtmlColor";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { HexColorPicker } from "react-colorful";

export interface ColorPickerProps {
  color?: string;
  onChange?: (newColor: string) => void;
}

const ColorPicker = observer((props: ColorPickerProps) => {
  //console.log("ColorPicker", props);
  const theme = useTheme();
  const [color] = useState<string>(props.color || "0");
  const [anchorEl, setAnchorEl] = useState(null);
  const [newColor, setNewColor] = useState<string>(toHtmlColor(color));

  const handleOpen = (event: any) => {
    //console.log("handleOpen: ", event);
    if (anchorEl === null) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    //console.log("handleClose");
    setAnchorEl(null);
  };

  const handleChange = (htmlColor: string) => {
    //console.log("handleChange: ", htmlColor);
    setNewColor(htmlColor);

    const colorArgb = parseInt(htmlColor.substr(1), 16);
    //console.log("colorArgb: ", colorArgb);
  };

  useEffect(() => {
    if (anchorEl === null) {
      if (newColor !== toHtmlColor(color) && props.onChange) {
        props.onChange(newColor);
      }
    }
  }, [anchorEl]);

  const isOpen = Boolean(anchorEl);
  const colorStr = `#${Number(color).toString(16).toUpperCase()}`;
  //console.log("colorStr: ", colorStr);

  return (
    <Box
      sx={{
        position: "relative",
        width: "28px",
        height: "28px",
        cursor: "pointer",
        borderRadius: "8px",
        boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
        backgroundColor: newColor,
        border: 1,
        borderWidth: "3px",
        borderColor: theme.palette.background.default,
      }}
      onClick={handleOpen}
    >
      <Popover open={isOpen} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} sx={{ "& .MuiPaper-root": { overflow: "unset" } }}>
        <HexColorPicker color={colorStr} onChange={handleChange} />
      </Popover>
    </Box>
  );
});

export default ColorPicker;
